import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const DocKIDetailsPage = lazy(() =>
  import(
    "../../../../../components/WMS/Documents/DocKI/DocKIDetailsPage.tsx"
  ).then((module) => ({ default: module.DocKIDetailsPage })),
)

export const Route = createFileRoute("/_layout/WMS/documents/doc-ki/$docKi")({
  component: DocKIDetailsRoute,
})

function DocKIDetailsRoute() {
  return (
    <LazyRoutePage>
      <DocKIDetailsPage />
    </LazyRoutePage>
  )
}
